import { render, staticRenderFns } from "./VideoPageMobile.vue?vue&type=template&id=4ac7e620&scoped=true"
import script from "./VideoPageMobile.vue?vue&type=script&lang=js"
export * from "./VideoPageMobile.vue?vue&type=script&lang=js"
import style0 from "./VideoPageMobile.vue?vue&type=style&index=0&id=4ac7e620&prod&scoped=true&lang=scss"
import style1 from "./VideoPageMobile.vue?vue&type=style&index=1&id=4ac7e620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac7e620",
  null
  
)

export default component.exports